<template>
  <div>
    <Header/>
    <Navigationzj :toptNavi="10"/>
    <div class="xinwentou w1200">
      <em>公司动态</em>
    </div>
    <div class="news_list w1200" v-loading="qyloading">
      <!-- <ul class="info">
        <li v-for="(item, index) in list" :key="index">
          <router-link :to="{path: '/NewsDetail', query:{id:item.id}}" target="_blank" :title="item.title">
            <div class="clearfiximage">
              <img v-real-img="item.filename" src="../../assets/images/zwtp.jpg" width="130" height="130">
            </div>
            <div class="word">
              <h4 class="atpretitle">{{item.title}}</h4>
              <p>{{item.addtime}}</p>
            </div>
          </router-link>
        </li>
      </ul> -->
      <div class="box" v-for="(item, index) in list" :key="index">
        <router-link :to="{path: '/DynamicDate', query:{id:item.id}}" target="_blank" :title="item.title">
          <div class="newimage">
            <img v-real-img="item.filename" src="../../assets/images/zwtp.jpg" width="280" height="158">
          </div>
          <div class="word">
            <h4 class="newtext">{{item.title}}</h4>
            <p>{{item.addtime}}</p>
          </div>
        </router-link>
      </div>
      <!-- <ul>
        <li v-for="(item, index) in list" :key="index">
          <router-link :to="{path: '/NewsDetail', query:{id:item.id}}" target="_blank" :title="item.title">
            <div class="padd clearfix">
              <div class="news_list_l">
                <img v-real-img="item.filename" src="../../assets/images/zwtp.jpg" width="130" height="130">
              </div>
              <div class="news_list_r">
                <h3 class="atpresent_title">{{item.title}}</h3>
                <div class="news_list_c clearfix">
                  <em><img src="">{{item.addtime}}</em>
                  <em><img src=""> {{item.hit}}次</em>
                </div>
                <div class="news_list_b" v-html="escapeHTML(item.content)"></div>
              </div>
            </div>
          </router-link>
        </li>
      </ul> -->
    </div>
    <div class="hxq_subpage">
      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" :pageSizes="[12, 24, 36, 48, 60]" @pagination="LoadData" />
    </div>
    <Footer/>
  </div>
</template>
<script>
import api from '@/api/news'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import vuelist from '@/utils/vue_list'
import Navigationzj from '@/components/Navigationzj'
import Pagination from '@/components/Pagination'

export default {
  name: 'Dynamic',
  mixins: [vuelist],
  components: {
    Header,
    Navigationzj,
    Footer,
    Pagination
  },
  data () {
    return {
      api,
      listQuery: {
        page: 1,
        limit: 12,
        order: 'order_num',
        sort: 'asc',
        state: 3
      },
      qyloading: false,
      total: 5
    }
  },
  mounted () {
    this.LoadData()
  },
  methods: {
    escapeHTML (untrusted) {
      return untrusted.replace(/<(?:.|\n)*?>/gm, '')
        .replace(/(&rdquo;)/g, '/"')
        .replace(/&ldquo;/g, '/"')
        .replace(/&mdash;/g, '-')
        .replace(/&nbsp;/g, '')
        .replace(/&gt;/g, '>')
        .replace(/&lt;/g, '<')
        .replace(/<[\w\s"':=/]*/, '')
    }
  }
}
</script>
<style scoped>
  .atpresent_title{
    font-weight: 600;
  }
  .box {
    width: 280px;
    height: 245px;
    position: relative;
    animation: moveUp 1s forwards;
    float: left;
    margin-right: 20px;
    margin-top: 20px;
    border-radius: 10px;
    /* forwards属性会保持动画状态不回到初始状态 */
    box-shadow: 0px 1px 4px #0000007a;
  }
  @keyframes moveUp {
    0% {
      /* 定义动画开始的状态 */
      transform: translateY(0);
    }
    100% {
      /* 定义动画结束的状态 */
      transform: translateY(30px);
    }
  }
  .newimage {
    height: 158px;
    overflow: hidden;
  }
  .newimage img {
    border-radius: 10px;
    transition: 0.6s;
  }
  .newimage img:hover {
    transform:scale(1.3);
  }
  .newtext {
    color: #6a7e89;
    flex: 1 1 auto;
    font-size: 14px;
    font-weight: 700;
    min-height: 28px;
    padding: 0em 1em 0 1em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 20px;
  }
  .info {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .info li {
    cursor: pointer;
    width: 32%;
    margin-right: 1%;
  }
  .clearfiximage {
    width: 100%;
    height: 240px;
    overflow: hidden;
    background-size: 30%;
  }
  .clearfiximage img {
    transition: all .4s ease;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }
  .atpretitle {
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333;
  }
  .word {
    padding-top: 8px;
  }
  .word p {
    color: #999;
    font-size: 15px;
    margin-top: 10px;
    margin-left: 1em;
  }
  .news_list {
    min-height: 850px;
  }
</style>



// WEBPACK FOOTER //
// src/view/dynamic/Dynamic.vue